export function isBackgroundVideoSupported() {
  if (typeof window === 'undefined') {
    return true;
  }

  const testElement = document.createElement('video');

  return Boolean(
    testElement.canPlayType &&
      (testElement.canPlayType('video/mp4; codecs="avc1.42E01E"') ||
        testElement.canPlayType('video/mp4; codecs="mp4v.20.8"') ||
        testElement.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"')),
  );
}
